import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  CONFIRMATION_CODE,
  EMAIL,
  ID,
  REDIRECT_PAGE,
  RESET_CODE,
} from "@shared/constants/route-variables.constants";
import {
  CONNEXION,
  PAGE_NON_TROUVEE,
  PREMIERE_CONNEXION,
  REINITIALISATION_MOT_DE_PASSE,
} from "@shared/constants/route.constants";
import { AuthenticationService } from "@shared/services/authentication.service";
import { MembersService } from "@shared/services/members.service";
import { ProgressSpinnerModule } from "primeng/progressspinner";

@Component({
  selector: "app-user-redirect",
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  templateUrl: "./user-redirect.component.html",
  styleUrl: "./user-redirect.component.scss",
})
export class UserRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private membersService: MembersService,
    private authentication: AuthenticationService
  ) {}

  ngOnInit() {
    let userEmail = "";
    let userId = "";
    let resetCode = "";
    let confirmationCode = "";
    let redirectPage = "";
    this.route.queryParamMap.subscribe(params => {
      userEmail = params.get(EMAIL)!;
      userId = params.get(ID)!;
      resetCode = params.get(RESET_CODE)!;
      confirmationCode = params.get(CONFIRMATION_CODE)!;
      redirectPage = params.get(REDIRECT_PAGE)!;
      if (!userEmail || !resetCode || !userId || !confirmationCode || !redirectPage) {
        this.router.navigate([PAGE_NON_TROUVEE]);
      }
    });
    this.getMemberEnrollmentStatus(userId, userEmail, resetCode, confirmationCode, redirectPage);
  }

  getMemberEnrollmentStatus(
    userId: string,
    userEmail: string,
    resetCode: string,
    confirmationCode: string,
    redirectPage: string
  ) {
    this.membersService.isEnrolled(userEmail).subscribe(status => {
      status === true
        ? this.navigateBasedOnRedirectPage(redirectPage, resetCode, userId, userEmail)
        : this.confirmEmailMember(userId, confirmationCode, resetCode, userEmail);
    });
  }

  confirmEmailMember(userId: string, confirmationCode: string, resetCode: string, userEmail: string) {
    this.authentication.confirmEmail(userId, confirmationCode, userEmail).subscribe();
    this.router.navigate([PREMIERE_CONNEXION], {
      queryParams: { resetCode: resetCode, id: userId, email: userEmail },
    });
  }

  private navigateBasedOnRedirectPage(
    redirectPage: string,
    resetCode: string,
    userId: string,
    userEmail: string
  ): void {
    redirectPage === REINITIALISATION_MOT_DE_PASSE
      ? this.router.navigate([REINITIALISATION_MOT_DE_PASSE], {
          queryParams: {
            resetCode: resetCode,
            id: userId,
            email: userEmail,
          },
        })
      : this.router.navigate([CONNEXION], {
          queryParams: { email: userEmail },
        });
  }
}
